<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <md-button
            @click="
              (administratorInit = !administratorInit),
                (updateAdministratorInit = false)
            "
            >Add New Admin</md-button
          >
        </md-card-content>
      </md-card>
      <md-card v-if="administratorInit">
        <md-card-content>
          <form @submit.prevent class="form">
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Full Name</label>
                <md-input
                  required
                  v-model="administrator.fullname"
                  type="text"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-50">
              <md-field>
                <the-mask
                  placeholder="Phone"
                  id="md-input-00tt9ig"
                  class="md-input"
                  v-model="administrator.phone"
                  :mask="['(###) ###-####']"
                />
              </md-field>
            </div>

            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Email Address</label>
                <md-input
                  required
                  v-model="administrator.email"
                  type="text"
                ></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-50">
              <md-field v-if="!updateAdministratorInit">
                <label>Password</label>
                <md-input
                  required
                  v-model="administrator.password"
                  type="text"
                ></md-input>
              </md-field>
            </div>
          </form>
        </md-card-content>
        <!-- <md-card-content>
          <label>Permissions</label>
          <div>
            <div v-for="(p, i) in permissions" :key="i">
              <div v-if="p.children.length">
                <input type="checkbox" v-model="administrator.permissions" :value="p" />
                {{p.name}}
                <ul>
                  <li v-for="(c,y) in p.children" :key="y">
                    <input
                      type="checkbox"
                      :disabled="checkParent()"
                      :value="c"
                      v-model="administrator.permissions"
                    />
                    {{c.name}}
                  </li>
                </ul>
              </div>
              <div v-else>
                <input type="checkbox" :value="p" v-model="administrator.permissions" />
                {{p.name}}
              </div>
            </div>
          </div>
        </md-card-content> -->

        <md-card-actions md-alignment="space-between">
          <md-button
            v-if="!updateAdministratorInit"
            class="md-primary md-round md-small"
            @click="validate()"
            >Save</md-button
          >
          <md-button
            v-else
            class="md-primary md-round md-small"
            @click="update()"
            >Save</md-button
          >

          <md-button class="md-primary md-round md-small" @click="cancel()"
            >Cancel</md-button
          >
        </md-card-actions>
      </md-card>
      <md-card v-else>
        <md-card-content>
          <md-table
            md-fixed-header
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="diamonds">Per page</label>
                <md-select v-model="pagination.perPage" name="diamonds">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>
              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Search records"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row
              slot="md-table-row"
              :style="{
                backgroundColor:
                  item.hasOwnProperty('needs_approval') && item.needs_approval
                    ? 'rgba(253, 207, 207, 0.68)'
                    : 'none'
              }"
              slot-scope="{ item }"
            >
              <md-table-cell md-label="Name" md-sort-by="shape">{{
                item.fullname
              }}</md-table-cell>
              <md-table-cell md-label="Email" md-sort-by="price">{{
                item.email
              }}</md-table-cell>
              <md-table-cell md-label="Phone" md-sort-by="price">{{
                item.phone
              }}</md-table-cell>
              <md-table-cell md-label="Edit">
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>edit</md-icon>
                </md-button>
              </md-table-cell>
              <md-table-cell md-label="Delete">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon style="color: rgb(31, 71, 154) !important"
                    >close</md-icon
                  >
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import firebase from "firebase";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import router from "@/router";
import { db, functions } from "@/config/firebaseInit";
import axios from "axios";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      administratorInit: false,
      updateAdministratorInit: false,
      currentSort: "name",
      currentSortOrder: "asc",
      permissions: [
        {
          name: "Super Admin",
          isAllowed: true,
          children: []
        },
        {
          name: "Media Players",
          isAllowed: true,
          children: []
        },
        {
          name: "Administration",
          isAllowed: true,
          children: []
        },
        {
          name: "Media",
          isAllowed: true,
          children: [
            {
              name: "Media Library",
              isAllowed: true
            },
            {
              name: "Media Collection",
              isAllowed: true
            },
            {
              name: "Media Gallery",
              isAllowed: true
            }
          ]
        },

        {
          name: "Announcements",
          isAllowed: true,
          children: []
        }
      ],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      footerTable: ["Name", "Email", "Phone", "Edit", "Delete"],
      searchQuery: "",
      propsToSearch: ["firstname", "lastname", "email"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      administrator: {
        fullname: "",
        phone: "",
        permissions: [],
        email: "",
        password: null
      },
      inviteEmail: null,
      showDialog: false
      //sendEmail: functions.httpsCallable("sendEmail")
    };
  },
  watch: {
    updateAdministratorInit() {
      if (!this.updateAdministratorInit) {
        this.administrator = {
          fullname: "",
          phone: "",
          email: "",
          password: null
        };
      }
    }
  },
  firestore() {
    return {
      tableData: db.collection("administrator")
    };
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  methods: {
    checkParent() {
      let checked = this.administrator.permissions.filter(
        p => p.name === "Media"
      )[0];

      if (checked) {
        return false;
      }

      return true;
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (
          (this.currentSort === "created") &
          (this.currentSortOrder === "desc")
        ) {
          return a[sortBy] - b[sortBy];
        }

        if (
          (this.currentSort === "created") &
          (this.currentSortOrder === "asc")
        ) {
          return b[sortBy] - a[sortBy];
        }

        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleEdit(administrator) {
      this.administrator = administrator;
      this.administratorInit = true;
      this.updateAdministratorInit = true;
    },
    cancel() {
      this.administratorInit = false;
      this.updateAdministratorInit = false;
    },
    update() {
      let administratorRef = db
        .collection("administrator")
        .doc(this.administrator.id);
      let administrator = this.administrator;

      return administratorRef.set(administrator, { merge: true }).then(() => {
        this.updateAdministratorInit = false;
        this.administratorInit = false;
        this.administrator = {
          fullname: "",
          email: "",
          password: null
        };
        setTimeout(function() {
          return Swal.fire("Success", "Administrator Updated", "success");
        }, 500);
      });
    },
    signUp() {
      let vm = this;
      firebase
        .auth()
        .createUserWithEmailAndPassword(
          this.administrator.email,
          this.administrator.password
        )
        .then(
          function(msg) {
            setTimeout(() => {
              vm.saveUser();
            }, 300);
          },
          function(err) {
            alert(err.message);
          }
        );
      // firebase
      //   .auth()
      //   .createUserWithEmailAndPassword(
      //     this.administrator.email,
      //     this.administrator.password
      //   )
      //   .then(u => {
      //     this.saveUser();
      //     let administrator = this.administrator;
      //     administrator.uid = u.user.uid;
      //     u.user.updateProfile({
      //       displayName: administrator.fullname
      //     });
      //   })
      //   .catch(err => {
      //     return Swal.fire("Error", err.message, "warning");
      //   });
    },
    validate(id) {
      let valid = true;
      for (let key in this.administrator) {
        if (key !== "phone" && !this.administrator[key]) {
          valid = false;
        }
      }
      if (valid) {
        this.signUp();
      } else {
        Swal.fire("Error", "Missing Required Fields", "warning");
      }
    },
    saveUser() {
      console.log("saving user");
      // delete this.administrator.password;
      db.collection("administrator")
        .doc()
        .set(this.administrator, { merge: true })
        .then(() => {
          Swal.fire("Success", "User added", "success").then(() => {
            this.$router.go(-1);
          });
        });
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          return db
            .collection("administrator")
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire("Deleted!", "The page has been deleted.", "success");
            });
        }
      });
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.invite-modal {
  width: 500px;
}

.invite-wrapper {
  width: 75%;
  margin: 0 auto;
}

.form {
  display: flex;
  flex-wrap: wrap;
}
</style>
